import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Label, TreeNavDivider } from "@animech/ui";
import * as Styled from "./multiple-boxes-toggle.style";
import { useAppDispatch, useAppSelector, selectors, actions } from "store";
import { TactonApplication } from "api/tacton/types";
import { Toggle } from "ui/components/elements/toggle";
import { InfoButton } from "ui/components/elements/info-button";
import { isMultipleBoxesFeatureAvailable } from "utility/feature-availability";
/**
 * The opt-in switch for working with a pallet of boxes. Everything multi-box
 * (the pallet and its size, the palletizing presets and the stacking layers on
 * the canvas) only appears once this is on.
 *
 * It sits at the top of the object group in the sidebar, styled like the other
 * parameters there (label, info button, caption), so the feature is easy to
 * discover. Only shown for the cardboard application, where boxes exist, and
 * only where the feature is released (see `isMultipleBoxesFeatureAvailable`).
 */
export var MultipleBoxesToggle = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var activeApplication = useAppSelector(selectors.selectActiveApplication);
    var multipleBoxesEnabled = useAppSelector(selectors.selectMultipleBoxesEnabled);
    if (!isMultipleBoxesFeatureAvailable())
        return null;
    if (activeApplication !== TactonApplication.CARDBOARD)
        return null;
    var label = t("sidebar.object_shape.multiple_boxes");
    return (_jsxs(_Fragment, { children: [_jsxs(Styled.MultipleBoxesToggle, { children: [_jsxs("div", { className: "".concat(Styled.prefix, "-text"), children: [_jsxs(Label, { className: "".concat(Styled.prefix, "-label"), children: [label, _jsx(InfoButton, { title: label, description: {
                                            long: t("sidebar.object_shape.multiple_boxes_description"),
                                        } })] }), _jsx("span", { className: "".concat(Styled.prefix, "-caption"), children: t("sidebar.object_shape.multiple_boxes_caption") })] }), _jsx(Toggle, { "aria-label": label, checked: multipleBoxesEnabled, onChange: function (event) {
                            return dispatch(actions.setMultipleBoxesEnabled(event.target.checked));
                        } })] }), _jsx(TreeNavDivider, {})] }));
};
